export default "__VITE_ASSET__khoVxiSS__"